import { BaseRollerProductType } from '../constants/productTypes';
import { ProductBuilderMachineContext } from '../types';

export const isRollerDayNight = ({
  products,
}: ProductBuilderMachineContext) => {
  const rollerDayNightChainlessBaseProductType: BaseRollerProductType =
    'Roller Blind Single Chainless';
  const rollerDayNightChainBaseProductType: BaseRollerProductType =
    'Roller Blind Single Chain';
  const location = window.location.pathname.includes('roller-day-night');
  return (
    (products[0].type.includes(rollerDayNightChainlessBaseProductType) &&
      location) ||
    (products[0].type.includes(rollerDayNightChainBaseProductType) && location)
  );
};
